// This file exports an array of expense categories.

export const expenseCategory = [
  // The category of expenses related to advertising.
  'advertising',
  // The category of expenses related to marketing.
  'marketing',
  // The category of expenses related to software.
  'software',
  // The category of expenses related to travel.
  'travel',
  // The category of expenses related to utilities.
  'utilities',
  // The category of expenses related to clothing.
  'clothing',
  // The category of expenses related to drinks.
  'drinks',
  // The category of expenses related to food.
  'food',
  // The category of expenses related to transport.
  'transport',
  // The category of expenses related to medical care.
  'medical',
  // The category of expenses related to insurance.
  'insurance',
  // The category of expenses related to repairs.
  'repairs',
  // The category of expenses related to rent.
  'rent',
  // The category of expenses related to electricity.
  'electricity',
  // The category of expenses related to internet access.
  'internet',
  // The category of expenses related to taxes.
  'taxes',
  // The category of expenses related to petrol.
  'petrol',
  // The category of expenses related to entertainment.
  'entertainment',
  // The category of expenses related to salaries.
  'salaries',
  // The category of expenses related to debt.
  'debt',
  // The category of expenses that do not fit into any other category.
  'others',
  // The category of expenses that are small and insignificant.
  'petty'
];
